export default __webpack_public_path__ + "static/media/ilustración-cuentavista.7d5971b0.svg";